import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

export default function SocialMedia() {

  return (
    <>
    <Helmet>
        <title>Stay Connected and Engage with Our Social Media</title>
        <meta property="og:title" content="Stay Connected and Engage with Our Social Media"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/social-media"/>
        <meta property="og:description" content="Looking to stay up-to-date with the latest news and updates from our company? Follow us on social media! Our pages on Facebook, Twitter, and Instagram are the perfect way to stay connected with us and engage with our community. From exciting new product launches to behind-the-scenes peeks at our team and office, our social media pages offer a window into everything that's happening at our company. Plus, with opportunities to participate in contests, giveaways, and other interactive activities, our social media pages are a great way to get involved and connect with others. Follow us today and join the conversation!"/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>
        <link rel="canonical" href="https://desirestore.online/social-media" />

        <meta name="title" content="Stay Connected and Engage with Our Social Media"/>
        <meta name="description" data-rh="true" content="Looking to stay up-to-date with the latest news and updates from our company? Follow us on social media! Our pages on Facebook, Twitter, and Instagram are the perfect way to stay connected with us and engage with our community. From exciting new product launches to behind-the-scenes peeks at our team and office, our social media pages offer a window into everything that's happening at our company. Plus, with opportunities to participate in contests, giveaways, and other interactive activities, our social media pages are a great way to get involved and connect with others. Follow us today and join the conversation!"/>
        <meta name="keywords" content="Developer, DesireStore.Online, web development, projects, experience, e-commerce, user-friendly, portfolio, expertise, attention to detail, web development trends, technologies."/>
      </Helmet>
      <div className="container" style={{display:"block"}}>

        <h2>Meet Our Team</h2>

        <div className="Social-card">
          <div className="background"></div>

          <div className="outer-div">
            <div className="inner-div">
              <div className="front">
                <div className="front__bkg-photo"></div>
                <div className="front__face-photo"></div>
                <div className="front__text">
                  <h3 className="front__text-header">Ayush Solanki</h3>
                  <p className="front__text-para">
                  <i className="fa-solid fa-code"></i> Developer
                  </p>

                  <span className="front__text-hover">Follow</span>
                </div>
              </div>
              <div className="back">
                <div className="social-media-wrapper">
                
                  <Link to="/" className="social-icon">
                    <i className="fab fa-github-square" aria-hidden="true"></i>
                  </Link>
                  <Link to="https://twitter.com/ayushSolanki29" className="social-icon">
                    <i
                      className="fa-brands fa-twitter"
                      aria-hidden="true"
                    ></i>
                  </Link>
                  <Link to="https://instagram.com/ayushsolanki.exe?igshid=NzMyMjgxZWIzNw==" className="social-icon">
                    <i className="fab fa-instagram" aria-hidden="true"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="background"></div>

<div className="outer-div">
  <div className="inner-div">
    <div className="front">
      <div className="front__bkg-photo"></div>
      <div className="front__face-photo" id="face-photo"></div>
      <div className="front__text">
        <h3 className="front__text-header">Rinkesh Patel</h3>
        <p className="front__text-para">
        <i class="fa-solid fa-bullhorn"></i> Marketer
        </p>

        <span className="front__text-hover">Follow</span>
      </div>
    </div>
    <div className="back">
      <div className="social-media-wrapper">
        <Link to="https://instagram.com/rinkesh__p_x64?igshid=ZWIzMWE5ZmU3Zg==" className="social-icon">
          <i className="fab fa-instagram" aria-hidden="true"></i>
        </Link>
        <Link to="/" className="social-icon">
          <i className="fab fa-github-square" aria-hidden="true"></i>
        </Link>
        <Link to="/" className="social-icon">
          <i
            className="fab fa-linkedin-square"
            aria-hidden="true"
          ></i>
        </Link>
        <Link to="https://twitter.com/Linktomic__Plays" className="social-icon">
          <i className="fa-brands fa-twitter" aria-hidden="true"></i>
        </Link>
      </div>
    </div>
  </div>
</div>
        </div>
        <p>Experience our brand through the power of social media.</p>
      </div>
    </>
  );
}
